import React from "react";

const backdropStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 3000,
  backgroundColor: "rgba(0, 0, 0, 0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "16px",
};

const modalStyle = {
  width: "100%",
  maxWidth: "420px",
  background: "#ffffff",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
};

const titleStyle = {
  margin: 0,
  marginBottom: "16px",
  color: "#393D44",
  fontSize: "20px",
};

const listStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginBottom: "14px",
};

const optionButtonStyle = {
  width: "100%",
  textAlign: "left",
  border: "1px solid #DADADA",
  borderRadius: "8px",
  background: "#ffffff",
  color: "#393D44",
  padding: "12px 14px",
  cursor: "pointer",
  fontSize: "15px",
};

const cancelButtonStyle = {
  width: "100%",
  border: "1px solid #393D44",
  borderRadius: "8px",
  background: "#ffffff",
  color: "#393D44",
  padding: "10px 14px",
  cursor: "pointer",
  fontSize: "14px",
};

function GtmPaymentMethodModal({
  open,
  methods = [],
  title = "Sélectionnez votre mode de paiement",
  onSelect,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div style={backdropStyle} role="dialog" aria-modal="true" aria-label={title}>
      <div style={modalStyle}>
        <h3 style={titleStyle}>{title}</h3>
        <div style={listStyle}>
          {methods.map((method) => (
            <button
              key={String(method.id)}
              type="button"
              style={optionButtonStyle}
              onClick={() => onSelect?.(method)}
            >
              {method.label}
            </button>
          ))}
        </div>
        <button type="button" style={cancelButtonStyle} onClick={onCancel}>
          Annuler
        </button>
      </div>
    </div>
  );
}

export default GtmPaymentMethodModal;
